module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-cryptocurrency-e27c8ca4f86f43e39a5c4744ec9255da.png";